<template>
    <div>
        <!--模板选择-->
        <el-dialog :visible.sync="isShowMoudle"
                   :width="dialogWidth"
                   :style="{top: dialogTop}"
                   class="responsive-dialog">
            <template #title>
                <h2 class="text-xl font-bold">选择适合你的咨询记录模板</h2>
            </template>
            <div class="flex flex-col md:flex-row" :style="{height: dialogContentHeight}">
                <!-- 左侧模板列表 -->
                <div class="w-full md:w-2/5 h-[200px] md:h-[430px] mb-4 md:mb-0 md:mr-4 overflow-y-auto scrollable">
                    <div class="relative">
                        <div v-for="(edition,index) in editionList" :key="index"
                             class="flex justify-between h-[80px] bg-gray-100 border-1 rounded-lg mb-3 shadow-md md:flex-row"
                             :class="{
                                'border-blue-600 border-2': index === editionDetailId,  'flex-row': isSmallScreen,  'flex-col': !isSmallScreen}"
                             @click="showEditionDetail(index)">
                            <div class="h-full w-[70px] md:w-[80px] rounded-l-lg overflow-hidden">
                                <img class="h-full w-full object-cover"
                                     src="https://www.emojump.com/_nuxt/cognitiveBehavioral.dkfFQo3o.jpeg"
                                     alt="模板封面">
                            </div>
                            <div class="p-2 flex-1">
                                <div class="pb-1 flex justify-between">
                                    <div class="text-sm md:text-sm font-bold">{{edition.editionName}}</div>
                                </div>
                                <div class="text-xs font-normal line-clamp-2">{{edition.tipInfo}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧模板详情 -->
                <div class="w-full md:w-3/5 h-[300px] md:h-[500px] overflow-y-auto scrollable">
                    <div class="flex flex-col gap-3 p-2">
                        <div class="text-base font-semibold text-left">
                            模板简介
                            <div class="text-sm md:text-base font-normal mt-2">{{editionList[editionDetailId].tipInfo}}</div>
                        </div>
                        <div class="text-base font-semibold text-left">模板示例</div>

                        <div v-for="(subitem, index2) in editionList[editionDetailId].subitemlist" :key="index2"
                             class="px-3 pb-3 py-2 rounded-lg" :style="{backgroundColor: getRandomColor()}">
                            <div class="px-3 mb-2 mt-2 flex relative items-center">
                                <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/conclusion_icon_summarize.svg"
                                     class="mr-2 h-4 md:h-5 w-4 md:w-5">
                                <h5 class="text-h5">{{subitem.title}}</h5>
                            </div>

                            <div v-for="(inneritem, index3) in subitem.subitemlist" class="ml-1 px-1" :key="index3">
                                <div class="relative p-3 mx-1 mt-2 bg-white rounded-lg color-[#353E6D99] text-xs md:text-13px font-normal">
                                    <div class="mb-1.5 flex items-center text-subtitle-1">
                                        <div class="mr-2 bg-[#ffe8f5] rounded-full h-2 w-2 overflow-hidden p-1.5"></div>
                                        {{inneritem.itemTitle}}
                                    </div>
                                    <div class="text-body-2 leading-5 text-left mr-2 ml-2">
                                        <div>{{inneritem.itemContent}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="flex justify-end pt-6">
                    <el-button type="primary" @click="ensureUseEdition()">确认使用</el-button>
                </div>
            </template>
        </el-dialog>

        <AddVisitorDialog v-model="isVisitorVisible" @addVConfirm="addVisitorConfirm"> </AddVisitorDialog>
        <!--提示-->
        <el-dialog title="支持格式" :visible.sync="formatShow">
            <div class="v-card-text d-flex flex-column gap-y-2">
                <div>
                    音频文件：
                    <span class="text-[#9da2b9]">
                        单个文件最长4个小时
                    </span>
                </div>
                <div>
                    音频格式：
                    <span class="text-[#9da2b9]">
                        {{allowedFileTypes.slice(0,allowedFileTypes.length-2)}}
                    </span>
                </div>
                <div>
                    文字稿文件格式：
                    <span class="text-[#9da2b9]">
                        {{allowedFileTypes.slice(allowedFileTypes.length-2,allowedFileTypes.length)}}
                    </span>
                </div>
                <div>
                    文字稿内容要求：
                    <span class="text-[#9da2b9]">
                        请按照对话格式进行上传（如：咨询师：......；来访者：......）
                    </span>
                </div>
                <div>
                    例如：
                </div>
                <div class="rounded-lg bg-[#f9faff] p-4 text-[#9da2b9]">
                    <div>
                        咨询师：你好，欢迎来到心理咨询室。最近过的怎么样？
                    </div>
                    <div>
                        来访者：最近很焦虑，总是失眠。
                    </div>
                    <div>
                        咨询师：最近发生什么事情了吗？
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 共听 -->
        <el-dialog title="创建咨询记录" :visible.sync="listenShow" width="58%">
            <div class="overflow-y-auto scrollable w-full" style="height: 440px;">
                <div class="w-full flex justify-center items-center">
                    <el-upload ref="upload"
                                action="#"
                                :auto-upload="false"
                                :before-upload="beforeUpload"
                                :on-change="handleChange"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :on-exceed="handleExceed"
                                :limit="1"
                                :file-list="fileList"
                                drag>
                        <div slot="trigger" class="flex items-center justify-center mt-12 ">
                            <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/icon/conclusion_upload.png" />
                            <p>拖放文件或点击上传</p>
                        </div>
                        <template #tip>
                            <div class="el-upload__tip flex items-center justify-center ">
                                <el-button type="primary" size="small" @click="formatShow=true">点击查看格式</el-button>
                            </div>
                        </template>
                    </el-upload>
                </div>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <div class=" flex flex-col mb-2 ">
                            <label class="block text-gray-700 text-left text-sm font-bold mb-2"> 语言</label>
                            <el-select v-model="form_addvisitor.useLanguage" placeholder="选择语言">
                                <el-option label="普通话" value="mandarin"></el-option>
                                <el-option label="英语" value="english"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="flex flex-col mb-2">
                            <label class="block text-gray-700 text-left text-sm font-bold mb-2">对话时间</label>
                            <el-date-picker v-model="form_addvisitor.visitDate"
                                            class=""
                                            type="datetime"
                                            clearable
                                            placeholder="选择日期时间" style="width: 98%;" />
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="12">
                        <div class=" flex flex-col mb-2 ">
                            <div class="flex justify-between">
                                <label class="block text-gray-700 text-left text-sm font-bold mb-2"> 来访者</label>
                                <button type="button" class="flex items-center text-blue-600" @click="isVisitorVisible=true">
                                    <i class="fa fa-user-plus" />
                                    <span>新增来访者</span>
                                </button>
                            </div>
                            <el-select v-if="vobj" v-model="form_addvisitor.visitorName" placeholder="选择"
                                       filterable @change="handleSelectVisitorChange"
                                       disabled
                                       >
                                <el-option v-for="(name, index) in allNames"
                                           :key="index"
                                           :value="name"
                                           disabled
                                           >
                                    <template #default>
                                        <div class="rounded-full w-8 " :style="{ backgroundColor: allColors[index]}">
                                            <span class="ml-2">{{form_addvisitor.visitorName.charAt(0)}}</span>
                                            <span class="ml-4">{{form_addvisitor.visitorName}}</span>
                                        </div>
                                    </template>
                                </el-option>
                            </el-select>
                            <el-select v-else v-model="form_addvisitor.visitorName" placeholder="选择"
                                       filterable @change="handleSelectVisitorChange">
                                <el-option v-for="(name, index) in allNames"
                                           :key="index"
                                           :value="name">
                                    <template #default>
                                        <div class="rounded-full w-8 " :style="{ backgroundColor: allColors[index]}">
                                            <span class="ml-2">{{name.charAt(0)}}</span>
                                            <span class="ml-4">{{name}}</span>
                                        </div>
                                    </template>
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-col :span="12">
                            <div class=" flex flex-col mb-2 ">
                                <label class="block text-gray-700 text-left text-sm font-bold mb-2"> 年龄</label>
                                <el-input v-model="form_addvisitor.age" placeholder="请输入年龄" required readonly />
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class=" flex flex-col mb-2 ">
                                <label class="block text-gray-700 text-left text-sm font-bold mb-2"> 生理性别</label>
                                <el-select v-model="form_addvisitor.gender" placeholder="请选择" disabled>
                                    <el-option label="男" value="male"></el-option>
                                    <el-option label="女" value="female"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-col>
                </el-row>

                <div class="overflow-x-hidden">
                    <label class="block text-gray-700 text-sm font-bold mb-2  text-left">个案分析模板</label>
                    <el-input readonly="" size="1" type="text" v-model="editionList[selectedEditionIndex].editionName">
                        <template #suffix>
                            <a class="mr-3 py-3 text-blue-700" @click="isShowMoudle=true">点击查看更多模板</a>
                        </template>
                    </el-input>
                </div>

                <!-- 模板展示 -->
                <div class="module-list flex justify-between mt-4">

                    <button v-for="(edition,index) in filteredEditionList"
                            :key="index"
                            class="border w-1/3 h-28 bg-gray-100 border- rounded-lg mr-4 mb-4"
                            :class="{' border-blue-500 ': index === selectedEditionIndex}"
                            @click="selectEdition(index)">
                        <label class="text-left block text-gray-700 text-sm font-bold p-4">{{ edition.editionName }}</label>
                        <p class="px-2 text-xs mb-0 line-clamp-3">{{ edition.tipInfo }}</p>
                    </button>

                </div>

                <div class="mt-4 mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2">来访背景关键信息</label>
                    <el-input type="textarea"
                                :rows="6"
                                v-model="form_addvisitor.backgroundInfo"
                                placeholder="请输入来访背景关键信息" />
                </div>
            </div>
            <div class="w-full rounded-lg">
                <el-button type="primary" class="w-full" @click="submitUploadFile">提交</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import axios from 'axios';
    import { ref } from 'vue';
    import AddVisitorDialog from './AddVisitorDialog.vue'; 
    
    export default {
        components: {
            AddVisitorDialog,
        },
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            vobj: {
                type: Object,
                default: null    
            }
        },
        watch: {
            value(newValue) {
                this.listenShow = newValue;
                if (newValue) {
                    this.getAllVisitors();
                }
            },
            vobj(newInfo) {
                if (newInfo && Object.keys(newInfo).length > 0) {
                    // 使用Vue.set确保响应式更新所有字段
                    Object.keys(newInfo).forEach(key => {
                        this.$set(this.form_addvisitor, key, newInfo[key]);
                    });
                }
            }
        },
        setup() {
            const form_addvisitor = ref({
                visitorName: '匿名',
                gender: '',
                age: '',
                visitDate: '',
                contact: '',
                backgroundInfo: '',
                symptoms:'',
                useLanguage: '普通话',
                visitorid:null,
            });

            return {
                form_addvisitor,
            };
        },
        computed: {
            filteredEditionList() {
                return this.editionList.slice(0, 3);
            },
            allColors() {
                return this.visitorShowList.reduce((acc, visitor) => {
                    const color = visitor.vinfos.map(vinfo => vinfo.color);
                    return acc.concat(color);
                }, []);
            },
            allNames() {
                return this.visitorShowList.reduce((acc, visitor) => {
                    const names = visitor.vinfos.map(vinfo => vinfo.visitorName);
                    return acc.concat(names);
                }, []);
            },
        },
        mounted() {
            // 初始化响应式尺寸
            this.updateDialogLayout();
            // 监听窗口大小变化
            window.addEventListener('resize', this.updateDialogLayout);

            if (this.vobj) {
                Object.keys(this.vobj).forEach(key => {
                    this.$set(this.form_addvisitor, key, this.vobj[key]);
                });
            }
        },
        beforeDestroy() {
            // 移除事件监听
            window.removeEventListener('resize', this.updateDialogLayout);
        },
        data() {
            return {
                dialogWidth: '70%',
                dialogTop: '-60px',
                dialogContentHeight: '430px',
                searchVisitorKey:"",
                visitorTryTime:6,
                isShowMoudle: false,
                isVisitorVisible: false,
                listenShow: false,
                formatShow: false,
                allowedFileTypes: [".wav", ".mp3", ".aac", ".midi", ".mpeg", ".0gg", ".opus", "webm", ".fac", "amr", ".m4a",".txt", ".docx"],                
                visitorList: [
                    {
                        index: "S",
                        vinfos: [
                            {
                                visitorid: "0",
                                visitorName: "识心",
                                gender: '男',
                                age: "18",
                                createdAt: "2025-02-15T15:01:26.000Z",
                                backgroundInfo: "第一次来",
                                color: `rgba(201, 139, 134, 0.3)` ,
                            }
                        ]
                    },                 
                ],
                fileList: [],
                visitorShowList:[],
                selectedEditionIndex: 0,
                editionDetailId:0,
                ScaleList:[{
                    "ScaleId": "",
                    "ScaleURL": "",
                    "ScaleClass": "",
                    "ScaleName": "",
                    "ScaleName_en": "",
                    "EvalInt": "",
                    "EvalIntInfo": "",
                    "EvalValue": "",
                    "EvalValueInfo": "",
                    "NOQ": "",//题目数量
                    "apply": "",
                    "EvalFrom": "",
                    "realUse": 0,
                    "use": 0,
                    "isVip": 0,
                },],
                cufFileNmae:null,
                editionList: [
                    {
                        editionId: "1",
                        editionName: "标准版",
                        editionSendName: "# 基础版",
                        tipInfo: "标准化心理咨询个案分析模板采用通用性设计，适用于不同理论取向的咨询流派，严格依照中国心理学会制定的咨询记录书写标准。该模板全面涵盖个案概念化、来访者主诉、咨询目标、咨询方法、咨询过程与步骤、评估与风险、咨询反思与建议等核心要素，确保对咨询内容进行客观、详实的记载，系统化呈现来访者的整体心理状况。",
                        subitemlist: [//大类级别
                            {
                                title: "个案概念化",
                                subitemlist: [
                                    {
                                        itemTitle: "基本信息：",
                                        itemContent: "来访者Z，19岁，男性，某重点大学理工科二年级学生，首次咨询",
                                    },
                                    {
                                        itemTitle: "呈现问题：",
                                        itemContent: "	近3个月持续出现入睡困难（日均睡眠<4小时）\n"+
                                        "注意力分散导致学业效率下降（本学期GPA较上季下降30%）\n"+
                                        '反复出现"我不可能成功"的侵入性思维',
                                    },

                                    {
                                        itemTitle: "背景因素：",
                                        itemContent: "	父母均为高知人群，家庭对学业成就期待较高\n"+
                                        "半年前未入选国家级科创团队关键事件\n"+
                                        "近期存在社交退缩（日均手机使用时长12小时+）",
                                    },


                                    {
                                        itemTitle: "心理机制假设：",
                                        itemContent: "	核心信念：自我价值=学业成就\n"+
                                        "维持因素：回避行为导致负向强化循环\n"+
                                        "保护因素：保持基本生活自理能力",
                                    },
                                ]
                            },
                            {
                                title: "来访者主诉",
                                subitemlist: [
                                    {
                                        itemTitle: "原话记录：",
                                        itemContent: "最近完全没法集中精神看书，每次打开教材就觉得心跳特别快...我知道这样下去会挂科，但越着急越学不进去。上周实验报告没写完，躲在卫生间哭了半小时...",
                                    },
                                ]
                            },
                            {
                                title: "咨询师咨询过程总结：",
                                subitemlist: [
                                    {
                                        itemTitle: "1. 咨询目标",
                                        itemContent: "近期目标（1-3次）：\n" +
                                            "\t建立安全情绪表达机制\n" +
                                            "\t睡眠质量改善至日均6小时\n" +
                                            "\t制定阶梯式学习计划\n" + "远期目标：\n" +
                                            "\t构建多元自我评价体系\n" +
                                            "\t提升压力情境下的情绪调节能力\n",
                                    },
                                    {
                                        itemTitle: "2. 咨询方法",
                                        itemContent: "\t认知解离技术（针对自我批判性思维）\n" +
                                            "\t行为激活练习（建立日常作息锚点）\n" +
                                            "\t焦点解决短期治疗（挖掘例外资源）\n",
                                    },
                                    {
                                        itemTitle: "3. 咨询过程与步骤",
                                        itemContent: "阶段进程：\n" +
                                            "1.\t初始阶段（0-15min）\n" +
                                            "\t建立咨询契约\n" +
                                            "\t使用情绪温度计技术量化焦虑程度（当前自评7/10分）\n" +
                                            ".\t工作阶段（15-40min）\n" +
                                            "\t探索\"失败认知\"的形成路径\n" +
                                            "\t共同构建\"例外时刻\"时间轴（发现大一时成功应对考试经历）\n" +
                                            "\t制定\"20分钟专注-5分钟放松\"的行为实验\n" +
                                            ".\t结束阶段（40-50min）\n" +
                                            "\t呼吸放松训练教学\n" +
                                            "\t商定家庭作业：记录每日3个微小成就\n",
                                    },
                                ]
                            },

                            {
                                title: "AI评估与风险",
                                subitemlist: [
                                    {
                                        itemTitle: "1.诊断印象：",
                                        itemContent: "初步评估为适应性障碍伴焦虑症状（依据ICD-11 6B43），需排除抑郁症可能，建议结合SDS量表评估。",
                                    },
                                    {
                                        itemTitle: "2.诊断依据：",
                                        itemContent: "a.\t适应性障碍诊断（ICD-11 6B43）\n" +
                                            "\t依据世界卫生组织《国际疾病分类第十一版》：\n" +
                                            " 压力源存在（未入选科创团队）\n" +
                                            " 症状出现在压力事件3个月内\n" +
                                            " 伴随明显社会功能损害（GPA下降30%）\n" +
                                            " 不符合其他精神障碍诊断标准\n" +
                                            ".\t抑郁症排查建议\n" +
                                            "\t参照《DSM-5》重性抑郁障碍诊断标准：\n" +
                                            " 需确认症状持续是否达2周\n" +
                                            " 重点评估：情绪低落频次、快感缺失程度、躯体症状",
                                    },
                                    {
                                        itemTitle: "3.进展评估：",
                                        itemContent: "\t咨访关系建立程度：★★★☆☆\n" +
                                            "\t目标达成进度：15%",
                                    },
                                    {
                                        itemTitle: "4.风险预警：",
                                        itemContent: "\t当前自杀风险评估：1级（无直接风险，存在被动死亡念头）\n" +
                                            "\t需关注昼夜节律紊乱导致的躯体化反应\n",
                                    },
                                ]
                            },

                            {
                                title: "AI对咨询的反思与建议",
                                subitemlist: [
                                    {
                                        itemTitle: "1.反思：",
                                        itemContent: "本次咨询在情绪聚焦方面取得突破，但对学业压力源的系统分析尚不充分。建议下次咨询引入时间饼图技术，并注意来访者谈及家庭时的躯体防御反应。\n" +
                                            "实例：学业压力源系统分析不足的具体表现\n" +
                                            "情境再现：\n" +
                                            "咨询中来访者陈述：\"每天从实验室回宿舍就开始刷题到凌晨，但越学效率越低，上周模电作业竟然错了基础题...\"\n" +
                                            "原处理方式：\n" +
                                            "a.\t聚焦情绪反应：引导来访者描述\"效率低下时的身体感受\"\n" +
                                            "b.\t认知重构：挑战\"必须熬夜学习\"的不合理信念\n" +
                                            "不足分析：\n" +
                                            "c.\t压力源时空分布盲区\n" +
                                            "\t未探查压力传导路径：实验室环境（设备噪音/竞争氛围）→ 宿舍学习状态\n" +
                                            "\t遗漏关键时段：忽略\"实验课后2小时\"的高反刍思维期\n" +
                                            ".\t压力层级未分化\n" +
                                            "\t将学业压力视为单一维度，未区分：\n" +
                                            " 课程压力（模电作业难度）\n" +
                                            " 竞赛压力（科创团队落选阴影）\n" +
                                            " 自我施压（每日学习时长≥14小时）\n" +
                                            "改进证据：\n" +
                                            "使用时间饼图技术后，发现：\n" +
                                            "\t72%的高压时段集中在17:00-21:00（实验课后续时段）\n",
                                    },
                                    {
                                        itemTitle: "2.后续咨询方向建议：",
                                        itemContent: "\t布置正念饮食练习（建立身心连接）\n" +
                                            "\t建议进行HAMD-17量表筛查\n" +
                                            "\t对来访者压力源进行持续解构\n" +
                                            "\t引导来访者来访者进行认知重构，增强自我关怀",
                                    },
                                ]
                            },
                        ]
                    },

                    {
                        editionName: "精神分析(动力学)",
                        editionSendName: "精神分析(动力学)",
                        editionId: "2",
                        tipInfo: "精神分析流派的咨询会谈记录报告侧重于探索来访者的潜意识世界，通过分析内心冲突、移情现象以及防御机制等，深入揭示其内在心理状态。这份报告旨在帮助咨询师更全面地理解来访者的行为动机、阻抗与防御模式以及移情反应，从而实现对个案的深入把握和有针对性的干预。",
                        subitemlist: [//大类级别
                            {
                                title: "主诉问题",
                                subitemlist: [
                                    {
                                        itemTitle: "主要困扰：",
                                        itemContent: "在社交场合感到强烈焦虑，回避同事聚会，伴随自我批评性思维\n问题强度：焦虑程度7/10（持续6个月）",
                                    },
                                    {
                                        itemTitle: "CBT三维分析模型：",
                                        itemContent: "维度\t\t\t 具体表现（AI自动提取标记）\n"+
                                        '认知 自动思维：""我一说话就会出丑""（灾难化）\n	 中间信念：""必须时刻表现完美才能被接纳""（条件化规则）\n	 核心信念：""我是不够好的""（自我维度）"\n',

                                    },

                                    {
                                        itemTitle: "自动化思维记录（AI结构化提取）",
                                        itemContent: "	触发情境\t自动思维内容\t情绪反应\t认知扭曲类型（AI标注）\n"+
                                                    '收到部门聚会通知\t"我肯定会说错话被嘲笑"\t焦虑90\t读心术/灾难化\n'+
                                                '会议发言前心跳加速\t"我的声音听起来一定在发抖"\t羞耻75\t情绪推理',
                                    },


                                    {
                                        itemTitle: "个案概念化模型（AI生成时间轴）：",
                                        itemContent: "	早期经验：\n"+
                                    '▸ 12岁因口吃被同学模仿 → 形成核心信念"我有缺陷"\n'+
                                    '维持机制\n'+
                                    '▸ 行为层面：回避社交 → 缺乏修正经验 → 强化"我不胜任"信念\n'+
                                    '▸ 认知层面：选择性关注尴尬时刻 → 忽视积极反馈\n'
                                    }, 
                                    {
                                         itemTitle: "干预方案建议（AI生成策略库）：",
                                         itemContent: '认知干预\n'+
                                                    '1.	苏格拉底式提问："是否有证据表明他人真的在嘲笑你？"\n'+
                                                    '2.	连续体技术：评估"说错话"的实际后果等级\n'+
                                                    '行为实验\n'+
                                                    '▶ 梯度暴露：从小组茶歇交谈逐步扩展到部门会议发言\n'+
                                                    '▶ 数据记录：实际负面评价次数 vs. 预期次数'
                                     },                                   
                                     
                                     {
                                        itemTitle: "AI分析总结：",
                                        itemContent: '	核心模式识别：\n'+
                                                    '"完美主义认知-预期焦虑-回避行为"的恶性循环（置信度92%）\n'+
                                                '风险预警：回避行为导致职业发展受限（严重度指数：★★★☆）'
                                    },
                                ]
                            },
                            {
                                title: "来访者主诉",
                                subitemlist: [
                                    {
                                        itemTitle: "原话记录：",
                                        itemContent: "最近完全没法集中精神看书，每次打开教材就觉得心跳特别快...我知道这样下去会挂科，但越着急越学不进去。上周实验报告没写完，躲在卫生间哭了半小时...",
                                    },
                                ]
                            },
                            {
                                title: "咨询师咨询过程总结：",
                                subitemlist: [
                                    {
                                        itemTitle: "1. 咨询目标",
                                        itemContent: "近期目标（1-3次）：\n" +
                                            "\t建立安全情绪表达机制\n" +
                                            "\t睡眠质量改善至日均6小时\n" +
                                            "\t制定阶梯式学习计划\n" + "远期目标：\n" +
                                            "\t构建多元自我评价体系\n" +
                                            "\t提升压力情境下的情绪调节能力\n",
                                    },
                                    {
                                        itemTitle: "2. 咨询方法",
                                        itemContent: "\t认知解离技术（针对自我批判性思维）\n" +
                                            "\t行为激活练习（建立日常作息锚点）\n" +
                                            "\t焦点解决短期治疗（挖掘例外资源）\n",
                                    },
                                    {
                                        itemTitle: "3. 咨询过程与步骤",
                                        itemContent: "阶段进程：\n" +
                                            "1.\t初始阶段（0-15min）\n" +
                                            "\t建立咨询契约\n" +
                                            "\t使用情绪温度计技术量化焦虑程度（当前自评7/10分）\n" +
                                            "2.\t工作阶段（15-40min）\n" +
                                            "\t探索\"失败认知\"的形成路径\n" +
                                            "\t共同构建\"例外时刻\"时间轴（发现大一时成功应对考试经历）\n" +
                                            "\t制定\"20分钟专注-5分钟放松\"的行为实验\n" +
                                            "3.\t结束阶段（40-50min）\n" +
                                            "\t呼吸放松训练教学\n" +
                                            "\t商定家庭作业：记录每日3个微小成就\n",
                                    },
                                ]
                            },

                            {
                                title: "AI评估与风险",
                                subitemlist: [
                                    {
                                        itemTitle: "1.诊断印象：",
                                        itemContent: "初步评估为适应性障碍伴焦虑症状（依据ICD-11 6B43），需排除抑郁症可能，建议结合SDS量表评估。",
                                    },
                                    {
                                        itemTitle: "2.诊断依据：",
                                        itemContent: "a.\t适应性障碍诊断（ICD-11 6B43）\n" +
                                            "\t依据世界卫生组织《国际疾病分类第十一版》：\n" +
                                            " 压力源存在（未入选科创团队）\n" +
                                            " 症状出现在压力事件3个月内\n" +
                                            " 伴随明显社会功能损害（GPA下降30%）\n" +
                                            " 不符合其他精神障碍诊断标准\n" +
                                            "b.\t抑郁症排查建议\n" +
                                            "\t参照《DSM-5》重性抑郁障碍诊断标准：\n" +
                                            " 需确认症状持续是否达2周\n" +
                                            " 重点评估：情绪低落频次、快感缺失程度、躯体症状",
                                    },
                                    {
                                        itemTitle: "3.进展评估：",
                                        itemContent: "\t咨访关系建立程度：★★★☆☆\n" +
                                            "\t目标达成进度：15%",
                                    },
                                    {
                                        itemTitle: "4.风险预警：",
                                        itemContent: "\t当前自杀风险评估：1级（无直接风险，存在被动死亡念头）\n" +
                                            "\t需关注昼夜节律紊乱导致的躯体化反应\n",
                                    },
                                ]
                            },

                            {
                                title: "AI对咨询的反思与建议",
                                subitemlist: [
                                    {
                                        itemTitle: "1.反思：",
                                        itemContent: "本次咨询在情绪聚焦方面取得突破，但对学业压力源的系统分析尚不充分。建议下次咨询引入时间饼图技术，并注意来访者谈及家庭时的躯体防御反应。\n" +
                                            "实例：学业压力源系统分析不足的具体表现\n" +
                                            "情境再现：\n" +
                                            "咨询中来访者陈述：\"每天从实验室回宿舍就开始刷题到凌晨，但越学效率越低，上周模电作业竟然错了基础题...\"\n" +
                                            "原处理方式：\n" +
                                            "a.\t聚焦情绪反应：引导来访者描述\"效率低下时的身体感受\"\n" +
                                            "b.\t认知重构：挑战\"必须熬夜学习\"的不合理信念\n" +
                                            "不足分析：\n" +
                                            "c.\t压力源时空分布盲区\n" +
                                            "\t未探查压力传导路径：实验室环境（设备噪音/竞争氛围）→ 宿舍学习状态\n" +
                                            "\t遗漏关键时段：忽略\"实验课后2小时\"的高反刍思维期\n" +
                                            "d.\t压力层级未分化\n" +
                                            "\t将学业压力视为单一维度，未区分：\n" +
                                            " 课程压力（模电作业难度）\n" +
                                            " 竞赛压力（科创团队落选阴影）\n" +
                                            " 自我施压（每日学习时长≥14小时）\n" +
                                            "改进证据：\n" +
                                            "使用时间饼图技术后，发现：\n" +
                                            "\t72%的高压时段集中在17:00-21:00（实验课后续时段）\n",
                                    },
                                    {
                                        itemTitle: "2.后续咨询方向建议：",
                                        itemContent: "\t布置正念饮食练习（建立身心连接）\n" +
                                            "\t建议进行HAMD-17量表筛查\n" +
                                            "\t对来访者压力源进行持续解构\n" +
                                            "\t引导来访者来访者进行认知重构，增强自我关怀",
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        editionName: "认知行为（CBT）",
                        editionSendName: "认知行为(CBT)",
                        editionId: "3",
                        tipInfo: "认知行为咨询的个案分析模板着重于展示来访者当前面临的问题和困扰，深入分析其背后隐藏的负性认知、情绪反应和行为模式。报告中需要详细记录来访者的自动思维和核心信念，并基于这些信息建立个案的概念化框架，明确阐述问题是如何形成和持续存在的。",
                        subitemlist: [//大类级别
                            {
                                title: "显性叙事与隐性动力（AI分离分析）",
                                subitemlist: [
                                    {
                                        itemTitle: "基本信息：",
                                        itemContent: "来访者Z，19岁，男性，某重点大学理工科二年级学生，首次咨询",
                                    },
                                    {
                                        itemTitle: "呈现问题：",
                                        itemContent: "	近3个月持续出现入睡困难（日均睡眠<4小时）\n"+
                                        "	注意力分散导致学业效率下降（本学期GPA较上季下降30%）\n"+
                                        '	反复出现"我不可能成功"的侵入性思维',
                                    },

                                    {
                                        itemTitle: "背景因素：",
                                        itemContent: "	父母均为高知人群，家庭对学业成就期待较高\n"+
                                        "	半年前未入选国家级科创团队关键事件\n"+
                                        "	近期存在社交退缩（日均手机使用时长12小时+）",
                                    },


                                    {
                                        itemTitle: "心理机制假设：",
                                        itemContent: "	核心信念：自我价值=学业成就\n"+
                                        "	维持因素：回避行为导致负向强化循环\n"+
                                        "	保护因素：保持基本生活自理能力",
                                    },
                                ]
                            },
                            {
                                title: "核心心理动力模型（AI生成三维矩阵）",
                                subitemlist: [
                                    {
                                        itemTitle: "'核心冲突关系主题（CCRT）",
                                        itemContent: '▸ 愿望：获得绝对安全认可（口欲期依赖残留）\n'+
                                                    '▸ 他人反应：感知为控制/贬低（投射性认同）\n'+
                                                    '▸ 自我反应：自我挫败行为 → 验证"我不配成功"信念\n',
                                    },
                                    {
                                        itemTitle: '主要防御机制（AI识别层级）',
                                        itemContent: '▶ 初级防御：退行（压力下出现暴食行为）\n'+
                                        '▶ 次级防御：理智化（用理论分析回避情感）\n'+
                                        '▶ 成熟防御： 升华（部分能量转入写作）',
                                    },
                                ]
                            },
                            {
                                title: "移情-反移情分析（AI关系模式建模）：",
                                subitemlist: [
                                    {
                                        itemTitle: "1. 咨询目标",
                                        itemContent: "近期目标（1-3次）：\n" +
                                            "\t建立安全情绪表达机制\n" +
                                            "\t睡眠质量改善至日均6小时\n" +
                                            "\t制定阶梯式学习计划\n" + "远期目标：\n" +
                                            "\t构建多元自我评价体系\n" +
                                            "\t提升压力情境下的情绪调节能力\n",
                                    },
                                    {
                                        itemTitle: "2. 咨询方法",
                                        itemContent: "\t认知解离技术（针对自我批判性思维）\n" +
                                            "\t行为激活练习（建立日常作息锚点）\n" +
                                            "\t焦点解决短期治疗（挖掘例外资源）\n",
                                    },
                                    {
                                        itemTitle: "3. 咨询过程与步骤",
                                        itemContent: "阶段进程：\n" +
                                            "1.\t初始阶段（0-15min）\n" +
                                            "\t建立咨询契约\n" +
                                            "\t使用情绪温度计技术量化焦虑程度（当前自评7/10分）\n" +
                                            "2.\t工作阶段（15-40min）\n" +
                                            "\t探索\"失败认知\"的形成路径\n" +
                                            "\t共同构建\"例外时刻\"时间轴（发现大一时成功应对考试经历）\n" +
                                            "\t制定\"20分钟专注-5分钟放松\"的行为实验\n" +
                                            "3.\t结束阶段（40-50min）\n" +
                                            "\t呼吸放松训练教学\n" +
                                            "\t商定家庭作业：记录每日3个微小成就\n",
                                    },
                                ]
                            },

                            {
                                title: "潜意识符号解码（AI关联性分析）",
                                subitemlist: [
                                    {
                                        itemTitle: "梦境素材：",
                                        itemContent:'"总梦见赶不上高铁，在月台摔倒被围观"\n'+
                                        '→ 符号解析：\n'+
                                        '▸ 高铁（社会竞争节奏） / 摔倒（阉割焦虑）\n'+
                                        '▸ 被围观（暴露恐惧 vs. 原始展示欲）\n',
                                    },
                                    {
                                        itemTitle: "口误标记：",
                                        itemContent: '将"晋升"误说为"禁升" → 反向形成机制激活（置信度89%）\n',
                                    },
                                ]
                            },

                            {
                                title: "发展轴线重构（AI生成心理年表）",
                                subitemlist: [
                                    {
                                        itemTitle: "固着点分析：",
                                        itemContent: '▸ 肛欲期（3岁）：如厕训练严苛 → 完美主义与反叛交替\n'+
                                    '▸ 俄狄浦斯期（5岁）：父亲长期缺席 → 未完成三角关系整合\n'+
                                    '重复模式：\n'+
                                    '职场权威关系 → 重现与抑郁母亲的共生-对抗循环\n'
                                    },
                                ]
                            },
                            {
                                title: "干预策略建议（AI生成策略库）",
                                subitemlist: [
                                    {
                                        itemTitle: "工作重点：",
                                        itemContent:'1.	处理移情神经症：澄清"咨询师-父亲"投射差异\n'+
                                        '2.	防御重构：将理智化转化为观察性自我\n'+
                                        '3.	潜意识意识化：通过"未赶上高铁"梦开展意象对话\n'
                                    },
                                    {
                                        itemTitle: "行为实验：",
                                        itemContent: '▶ 自由联想触发点："月台"→"童年车站送别"\n'+
                                                '▶ 解释时序：先联结行为模式，再揭示童年根源\n'
                                    },
                                ]
                            },
                             {
                             title: "AI分析总结",
                             subitemlist: [
                                 {
                                     itemTitle: "",
                                     itemContent:'阻抗指数：当前68/100（讨论父亲话题时升至82）\n'+
                                            '潜意识冲突图谱：依赖-自主冲突（强度★★★★☆）\n'+
                                            '风险预警：可能通过"忘记咨询时间"表达攻击（置信度74%）\n'
                                 },
                             ]
                         },
                        ]
                    },
],
            };
        },
        methods: {
            updateDialogLayout() {
                if (window.innerWidth < 768) { // 移动端
                    this.dialogWidth = '90%';
                    this.dialogTop = '0px';
                    this.dialogContentHeight = 'auto';
                } else { // 桌面端
                    this.dialogWidth = '70%';
                    this.dialogTop = '-60px';
                    this.dialogContentHeight = '430px';
                }
            },
            assignColors() {
                this.visitorList.forEach(visitorGroup => {
                    visitorGroup.vinfos.forEach(visitor => {
                        if (!visitor.color) {
                            visitor.color = this.getRandomColor();
                        }
                    });
                });
            },
            visitorFilter() {
                if (this.searchVisitorKey.trim() === '') {
                    this.visitorShowList = this.visitorList;
                } else {
                    this.visitorShowList = this.visitorList.map(visitor => {
                        return {
                            index: visitor.index,
                            vinfos: visitor.vinfos.filter(v => v.visitorName.includes(this.searchVisitorKey)) 
                        };
                    }).filter(visitor => visitor.vinfos.length > 0); 
                }
            },
            async getAllVisitors(){
              const token = localStorage.getItem('token');
              console.log("list token "+token);
              if (!token) {
                  return;
              }
              try {
                  const response = await axios.get('/api/getvisitors',  {
                      headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}`
                      }
                  });
                  if(response.data.code == "00"){
                      console.log('Login successful:', response.data);
                      if (response.data.visitorList.length > 0) {
                          this.visitorList = response.data.visitorList;
                          console.log(this.visitorShowList);
                          this.assignColors();
                          this.visitorFilter();
                      }
                  }else{                        
                      this.$message({
                          message: response.data.message,
                          type: response.data.type,                        
                      });
                  }
              } catch (error) {
                  console.error('get visitors error:', error);
                  if(this.visitorTryTime > 0){
                      this.visitorTryTime-=1;
                  }
              }
          },
            getRandomColor() {
                // 生成较淡的随机颜色
                const r = Math.floor(Math.random() * 120); // 红色值
                const g = Math.floor(Math.random() * 120); // 绿色值
                const b = Math.floor(Math.random() * 120); // 蓝色值

                // 计算平均值以生成浅色
                const lightColor = `rgba(${Math.floor(r + 128)}, ${Math.floor(g + 128)}, ${Math.floor(b + 128)}, 0.4)`;
                return lightColor;
            },
            ensureUseEdition(){
                this.selectedEditionIndex = this.editionDetailId;
                this.isShowMoudle = !this.isShowMoudle;
            },
            showEditionDetail(index){
                this.editionDetailId=index;
            },
            selectEdition(index) {
                this.editionDetailId=index;
                this.selectedEditionIndex = index; // 更新选中的版本
            },
            handleSelectVisitorChange(value) {
                var v ;
                this.visitorList.forEach(group => {
                // 筛选当前组中的 vinfos
                    const matchingVinfos = group.vinfos.filter(vinfo => vinfo.visitorName === value);                    
                    if (matchingVinfos.length >0) {
                            v = matchingVinfos[0];
                            console.log("====选择匹配========");
                            console.log(v);
                        }
                });
                            console.log(v.visitorid);
                this.form_addvisitor.visitorName = v.visitorName;
                this.form_addvisitor.age = v.age;
                this.form_addvisitor.gender = v.gender;
                this.form_addvisitor.backgroundInfo = v.backgroundInfo;
                this.form_addvisitor.symptoms = v.symptoms;
                this.form_addvisitor.contact = v.contact;
                this.form_addvisitor.visitorid = v.visitorid;
            },
            addVisitorClose() {
                this.form_addvisitor = {
                    visitorName: '匿名',
                    gender: '',
                    age: '',
                    visitDate: '',
                    contact: '',
                    symptoms:'',
                    backgroundInfo: '',
                    useLanguage: '普通话',
                    visitorid:null,
                };      
            },
            addVisitorConfirm(res) {
                console.log("22222222222222222");
                console.log(res);
                this.getAllVisitors();
            },
            beforeUpload(file) {
                if (!this.allowedFileTypes.includes(file.type)) {
                    this.errorMessage ="上传文件格式不允许";
                    return false;
                }
               /* // 检查文件大小
                if (file.size > this.maxFileSize) {
                    this.errorMessage = '文件大小不能超过 2MB';
                    return false; // 阻止上传
                }*/
                this.errorMessage = ''; // 清除错误信息
                return true; // 允许上传
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-1);
                this.cufFileNmae= file.name;
                console.log('Current file:', file);
                console.log('File list:', fileList);
            },
            handleSuccess(response, file) {
                alert('文件上传成功！');
                console.log(file, response);
            },
            handleError(err, file) {
                console.error("文件上传失败",err);
                this.errorMessage = '文件上传失败' + err + file;
            },
            handleExceed(files) {
                this.$message.warning('只能上传一个文件，新文件将覆盖旧文件');
                this.fileList = [];
                this.$refs.upload.clearFiles();
                this.$refs.upload.handleStart(files[0]);
            },
            UploadFilePreCheck() {
                if (this.fileList.length === 0) {
                    this.$message.error('请上传文件');
                    return false;
                }
                if (!this.form_addvisitor.visitDate) {
                    this.$message.error('请选择对话时间');
                    return false;
                }
                if (!this.form_addvisitor.age) {
                    this.$message.error('请选择来访者');
                    return false;
                }
                return true;
            },
            async submitUploadFile() {
                if (!this.UploadFilePreCheck()) { return; }
                const token = localStorage.getItem('token');
                const formData = new FormData();
                this.fileList.forEach(file => {
                    formData.append('files', file.raw); // 添加文件
                });
                
                console.log("======final=");
                console.log(this.form_addvisitor.visitorid);

                formData.append('visitor_id',this.form_addvisitor.visitorid);
                formData.append('backgroundInfo', this.form_addvisitor['backgroundInfo']);
                formData.append('visitDate', this.form_addvisitor['visitDate']);
                formData.append("edition", this.filteredEditionList[this.selectedEditionIndex].editionSendName);


                axios.post('/api/uploadfile', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    },
                })
                    .then(res => {
                        console.log(res);
                        this.$message.success('上传成功！');
                        setTimeout(() => {
                            this.listenShow = !this.listenShow;
                        }, 1000);
                        this.$emit('updateSuccess',this.cufFileNmae );
                    })
                    .catch(error => {
                        this.$message.error('上传失败: ' + error.message);
                    });
            },
        },
    };
</script>
<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');

    @media (max-width: 768px) {
        /* 对话框全屏显示 */
        .el-dialog {
            width: 95% !important;
            max-width: 100% !important;
            margin: 0 auto !important;
            top: 10px !important;
            height: calc(100vh - 20px);
            overflow-y: auto;
        }

        /* 模板选择区域改为垂直布局 */
        .flex {
            flex-direction: column;
            height: auto !important;
        }

        .w-2\/5, .w-3\/5 {
            width: 100% !important;
            margin-right: 0 !important;
            height: auto !important;
        }

        /* 上传区域调整 */
        .el-upload {
            width: 100% !important;
        }

        /* 表单元素调整 */
        .el-col {
            width: 100% !important;
            margin-bottom: 10px;
        }

        /* 模板按钮调整为单列 */
        .module-list {
            flex-direction: column;
        }

            .module-list button {
                width: 100% !important;
                margin-right: 0 !important;
                margin-bottom: 10px;
            }

        /* 字体大小调整 */
        .text-xl {
            font-size: 1.2rem;
        }

        .text-sm {
            font-size: 0.9rem;
        }

        /* 滚动区域高度调整 */
        .scrollable {
            max-height: 300px;
            overflow-y: auto;
        }

        /* 输入框和选择框调整 */
        .el-input, .el-select, .el-textarea {
            width: 100% !important;
        }

        /* 日期选择器调整 */
        .el-date-editor {
            width: 100% !important;
        }

        /* 模板详情区域调整 */
        .px-12px {
            padding-left: 8px;
            padding-right: 8px;
        }

        /* 按钮调整 */
        .el-button {
            width: 100%;
            margin-bottom: 10px;
        }
    }

    /* 通用滚动条样式 */
    .scrollable {
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f1f1f1;
    }

        .scrollable::-webkit-scrollbar {
            width: 6px;
        }

        .scrollable::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        .scrollable::-webkit-scrollbar-thumb {
            background-color: #c1c1c1;
            border-radius: 6px;
        }
    /* 响应式对话框样式 */
    .responsive-dialog {
        /* 移动端适配 */
        @media (max-width: 768px) {
            .el-dialog__body {
                padding: 15px;
            }

            .el-dialog__header {
                padding: 15px 15px 10px;
            }

            .el-dialog__footer {
                padding: 10px 15px 15px;
            }
        }
    }

    /* 滚动条美化 */
    .scrollable::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    .scrollable::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    .scrollable::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
    }

        .scrollable::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
        }
</style>
